import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
  legacy: false,
  locale: 'zh',  // 初始化配置语言
  messages: {
    zh: require('./config/zh.json')
  }
  // silentTranslationWarn: true  // 隐藏警告
})

export default i18n